module.exports = __webpack_public_path__ + "img/instagram.b373b734.jpeg";